<template>
  <div>
    <VCard title="Complaint Analysis 🙌">
      <VCardText>Coming Soon</VCardText>
    </VCard>
  </div>
</template>

<script setup>
definePage({
  meta: {
    name: 'complaint-dashboard',
  },  
})
</script>
